<template>
  <div class="photos-empty">
    <div class="body">
      <div class="content">
        <icon name="no-media-image" class="icon" />
        <span class="label">{{ $t("identity_data.no_photos") }}</span>
      </div>
    </div>
    <div class="footer" />
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
.photos-empty {
  width: 23rem;
  max-width: 100%;
}
.body {
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  aspect-ratio: 1;
  color: var(--text-color-dimmed);
  background: var(--container-background);
  border: 1px solid var(--button-default-border-color);
  border-bottom: 0;
}

.footer {
  box-sizing: border-box;
  min-height: 2rem;
  padding: 0.2rem;
  border: 1px solid var(--button-default-border-color);
  border-top: 0;
  border-radius: 0 0 0.5rem 0.5rem;
}
.content {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  align-items: center;
  width: 11.25rem;
}
.icon {
  width: 3rem;
  height: 3rem;
  fill: currentColor;
}
.label {
  font-size: 1rem;
  line-height: 1.25rem;
  text-align: center;
}
</style>
